import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";

export const schoolData = atomWithStorage("edu-school-data", {
  schoolName: "James Hope University",
  schoolLogo: "../assets/James-Hope-University-Logo.svg",
});

export const bioDataAtom = atomWithStorage<BioData>("edu-biodata", {
  firstName: "",
  middleName: "",
  lastName: "",
  gender: "",
  maritalStatus: "",
  religion: "",
  dob: "",
  phoneNumber: "",
  stateOfOrigin: "",
  lga: "",
  email: "",
  address: "",
  country: "",
  city: "",
  zipCode: "",
  disability: "",
  description: "",
});

export const paymentReceiptAtom = atom<Payment>({} as Payment);

// export const qualificationAtom = atomWithStorage<Qualification>("edu-qualifications", {} as Qualification);
// export const institutionAtom = atomWithStorage<Institution[]>("edu-institutions", []);
// export const WorkHistoryAtom = atomWithStorage<WorkHistory[]>("edu-work-history", []);
